export function setTitle(title: string): void {
    document.title = title ?? '';
}
